/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TradingBonusHistoryItem
 */
export interface TradingBonusHistoryItem {
  /**
   *
   * @type {number}
   * @memberof TradingBonusHistoryItem
   */
  timestamp?: number
  /**
   *
   * @type {number}
   * @memberof TradingBonusHistoryItem
   */
  referralsFee?: number
  /**
   *
   * @type {number}
   * @memberof TradingBonusHistoryItem
   */
  referralsReward?: number
  /**
   *
   * @type {number}
   * @memberof TradingBonusHistoryItem
   */
  teamFee?: number
  /**
   *
   * @type {number}
   * @memberof TradingBonusHistoryItem
   */
  teamReward?: number
}

export function TradingBonusHistoryItemFromJSON(json: any): TradingBonusHistoryItem {
  return TradingBonusHistoryItemFromJSONTyped(json, false)
}

export function TradingBonusHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradingBonusHistoryItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
    referralsFee: !exists(json, 'referralsFee') ? undefined : json['referralsFee'],
    referralsReward: !exists(json, 'referralsReward') ? undefined : json['referralsReward'],
    teamFee: !exists(json, 'teamFee') ? undefined : json['teamFee'],
    teamReward: !exists(json, 'teamReward') ? undefined : json['teamReward'],
  }
}

export function TradingBonusHistoryItemToJSON(value?: TradingBonusHistoryItem | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    timestamp: value.timestamp,
    referralsFee: value.referralsFee,
    referralsReward: value.referralsReward,
    teamFee: value.teamFee,
    teamReward: value.teamReward,
  }
}
